// PSP UI JS

document.addEventListener("DOMContentLoaded", () => {
  const icons = document.querySelectorAll(".xmb-icon");
  const audio = document.getElementById("psp-audio");
  const muteToggle = document.getElementById("mute-toggle");
  const bootScreen = document.getElementById("boot-screen");
  let current = 0;

  // Always show boot screen on each page load
  setTimeout(() => {
    bootScreen.style.display = "none";
  }, 3200); // Match pulse animation duration

  const updateSelection = (index) => {
    icons.forEach((icon, i) => {
      icon.classList.toggle("selected", i === index);
      icon.classList.remove("show-submenu");
    });
  };

  const playSound = (filename) => {
    const sfx = new Audio(`/files/${filename}`);
    sfx.volume = 0.3;
    sfx.play();
  };

  const moveLeft = () => {
    current = (current - 1 + icons.length) % icons.length;
    updateSelection(current);
    playSound("hover.mp3");
  };

  const moveRight = () => {
    current = (current + 1) % icons.length;
    updateSelection(current);
    playSound("hover.mp3");
  };

  const selectIcon = () => {
    const icon = icons[current];
    if (icon.dataset.hasSubmenu) {
      icon.classList.toggle("show-submenu");
    } else {
      playSound("select.mp3");
      setTimeout(() => {
        window.location.href = icon.dataset.link;
      }, 400);
    }
  };

  document.addEventListener("keydown", (e) => {
    if (bootScreen && bootScreen.style.display !== "none") return;

    switch (e.key) {
      case "ArrowLeft":
        moveLeft();
        break;
      case "ArrowRight":
        moveRight();
        break;
      case "Enter":
        selectIcon();
        break;
      case "m":
      case "M":
        toggleMute();
        break;
    }
  });

  icons.forEach((icon, index) => {
    icon.addEventListener("click", () => {
      current = index;
      updateSelection(current);
      selectIcon();
    });
  });

  // Submenu link clicks
  document.querySelectorAll(".submenu li").forEach((item) => {
    item.addEventListener("click", (e) => {
      playSound("select.mp3");
      setTimeout(() => {
        window.location.href = e.target.dataset.link;
      }, 400);
    });
  });

  // Mute button logic
  const toggleMute = () => {
    audio.muted = !audio.muted;
    muteToggle.textContent = audio.muted ? "🔇" : "🔊";
  };

  muteToggle.addEventListener("click", toggleMute);

  // Start ambient audio after boot
  setTimeout(() => {
    audio.play().catch(() => {});
  }, 3500);

  updateSelection(current);
});

// Block scrolling with arrow keys, spacebar, etc.
window.addEventListener("keydown", (e) => {
  const keys = ["ArrowUp", "ArrowDown", "PageUp", "PageDown", " "];
  if (keys.includes(e.key)) {
    e.preventDefault();
  }
}, { passive: false });

document.addEventListener('wheel', (e) => {
  e.preventDefault();
}, { passive: false });

document.addEventListener('touchmove', (e) => {
  e.preventDefault();
}, { passive: false });
